import Component from './component.js';
import './list-box.js';

/**
 * Вариант реализации паттерна
 * [СomboBox]{@link https://www.w3.org/WAI/ARIA/apg/patterns/combobox/}
 */
class ComboBox extends Component {
    /**
     * @type {HTMLInputElement}
     */
    input = null;

    /**
     * @type {import('./list-box.js').default}
     */
    menu = null;

    constructor() {
        super();
        this.addEventListener('keydown', this.onKeyDown);
        this.addEventListener('focusout', this.onFocusOut);
    }

    connectedCallback() {
        this.input = this.querySelector('input');
        this.input.role = 'combobox';
        this.menu = this.querySelector('list-box');
    }

    expand() {
        if (this.menu.options.length) {
            this.menu.selectedOption ??= this.menu.options.at(0);
            this.menu.tabIndex = 0;
            this.menu.show();
            this.menu.focus();
        }
    }

    collapse() {
        this.menu.tabIndex = -1;
        this.menu.hide();
        this.input.focus();
        this.input.select();
    }

    /**
     * @param {KeyboardEvent & {target: Element}} event
     */
    onKeyDown(event) {
        switch (event.key) {
            case 'ArrowDown':
                event.preventDefault();
                this.expand();
                break;
            case 'Escape':
                this.menu.hidden || event.stopPropagation();
                this.collapse();
                break;
        }
    }

    /**
     * @param {FocusEvent & {relatedTarget: Element}} event
     */
    onFocusOut(event) {
        if (!this.menu.contains(event.relatedTarget)) {
            this.menu.hide();
        }
    }
}

customElements.define('combo-box', ComboBox);
export default ComboBox;
